import { resolveDocumentTitle } from '@client/utils/navigation/route-header-resolution';
import { useMatches } from '@tanstack/react-router';
import { useEffect } from 'react';

/** Keeps `document.title` (the browser tab) in sync with the current route's `metadata.title`. */
export function useDocumentTitle() {
    const matches = useMatches();
    const title = resolveDocumentTitle(matches);

    useEffect(() => {
        document.title = title;
    }, [title]);
}
